import { locales, type Locale } from "./locales";

/** Keep each tab's application links in its rendered language. */
export function withLocaleHref(href: string, locale: Locale): string {
  // Accept application paths only; never turn an external URL into a local one.
  if (!href.startsWith("/") || href.startsWith("//") || /[\\\u0000-\u001f\u007f]/u.test(href)) {
    throw new Error("Expected a root-relative application URL");
  }
  if (!locales.includes(locale)) throw new Error("Unsupported locale");

  const hashIndex = href.indexOf("#");
  const hash = hashIndex < 0 ? "" : href.slice(hashIndex);
  const beforeHash = hashIndex < 0 ? href : href.slice(0, hashIndex);
  const queryIndex = beforeHash.indexOf("?");
  const pathname = queryIndex < 0 ? beforeHash : beforeHash.slice(0, queryIndex);
  const query = queryIndex < 0 ? "" : beforeHash.slice(queryIndex + 1);
  // Retain unrelated query bytes (including repeated keys and their encoding).
  const parameters = query ? query.split("&").filter((part) => !new URLSearchParams(part).has("lang")) : [];
  parameters.push(`lang=${locale}`);
  return `${pathname}?${parameters.join("&")}${hash}`;
}
